import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AuthContext from "../context/AuthProvider";

const REQUEST_PDF = `${process.env.REACT_APP_PDF_URL}`;
const PROFILE_URL = `${process.env.REACT_APP_API_URL}/account/profile`;

export function HomeDoctor() {
  const { setAuth, auth } = useContext(AuthContext);
  const navigate = useNavigate();
  const [passwordStatus, setPasswordStatus] = useState(null);

  useEffect(() => {
    const token = auth?.token;
    if (!token) return;

    const fetchPasswordStatus = async () => {
      try {
        const res = await axios.get(PROFILE_URL, {
          headers: { Authorization: token.toString() },
        });
        setPasswordStatus(res?.data?.password || null);
      } catch (err) {
        // Si falla el perfil no se muestra el aviso; la sesión la maneja RequireAuth.
        setPasswordStatus(null);
      }
    };

    fetchPasswordStatus();
  }, [auth?.token]);

  const logout = () => {
    setAuth({});
    window.localStorage.removeItem("auth");
    navigate("/login");
  };

  const productos = () => {
    navigate("/productos");
  };

  const goToProfile = () => {
    navigate("/perfil");
  };

  const abbr = (str) => {
    return str
      .split(" ")
      .map((item) => item[0])
      .join("");
  };

  const passwordDaysRemaining = passwordStatus?.dias_restantes;
  const showPasswordWarning =
    !passwordStatus?.expirado &&
    typeof passwordDaysRemaining === "number" &&
    passwordDaysRemaining <= 10;

  const passwordWarningText =
    passwordDaysRemaining <= 0
      ? "Tu contraseña vence hoy."
      : passwordDaysRemaining === 1
      ? "Tu contraseña vence mañana."
      : `Tu contraseña vence en ${passwordDaysRemaining} días.`;


  return (
    <div className="body-home">
      <div className="row header-int">
        <div className="col-md-4 d-none d-md-block">
          <p></p>
        </div>
        <div className="col-md-4 col-sm-12 logo-container">
          <p className="text-center">
            <img className="logo" src="/logo.png" alt="Ethical Nutrition" />
          </p>
        </div>
        <div className="col-md-4 d-none d-md-block">
          <p></p>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4 d-none d-md-block">
          <p></p>
        </div>

        <div className="col-md-4 col-sm-12 body-content-int">
          {/* === Aviso de contraseña por vencer === */}
          {showPasswordWarning && (
            <div className="pass-warning-banner">
              <p className="pass-warning-text">
                <i className="fas fa-exclamation-triangle me-1" />{" "}
                {passwordWarningText} Podés cambiarla ahora mismo.
              </p>
              <button
                type="button"
                className="pass-warning-btn"
                onClick={goToProfile}
              >
                Cambiar contraseña
              </button>
            </div>
          )}

          {/* === Tarjeta de usuario / Ver perfil === */}
          <div
            className="ecard-with-avatar pointer"
            onClick={goToProfile}
            role="button"
          >
            <div className="avatar">
              <p>{auth ? abbr(auth.username) : ""}</p>
            </div>

            <p className="title mb-1">{auth?.username}</p>

            <div className="view-profile-row">
              <i className="fas fa-user-circle me-1" />
              <span className="view-profile-text">Ver perfil</span>
              {showPasswordWarning && (
                <i className="bi bi-exclamation-triangle text-warning ms-2" />
              )}
            </div>
          </div>

          {/* === APPIT · Inicio de Tratamiento === */}
          <div className="ecard pointer" onClick={productos}>
            <p className="title">
              <span>
                <i className="fas fa-medkit"></i>
              </span>{" "}
              <span>APPIT · Inicio de Tratamiento</span> <span></span>
            </p>
          </div>

          {/* === Información de producto === */}
          <div className="ecard pointer">
            <p className="title">
              <a href={REQUEST_PDF} target="_blank" rel="noreferrer">
                <span>
                  <i className="fas fa-shopping-cart"></i>
                </span>{" "}
                <span>Información de producto</span> <span></span>
              </a>
            </p>
          </div>

          {/* === Salir === */}
          <div className="ecard-salir pointer text-end" onClick={logout}>
            <i className="fas fa-sign-out-alt"></i>
            <span className="ms-1">Salir</span>
          </div>
        </div>

        <div className="col-md-4 d-none d-md-block">
          <p></p>
        </div>
      </div>
    </div>
  );
}
